import React, { useState, useEffect } from "react";
import "./Content.css";
import {
  getAllBillsByMes,
  Mygastos,
  postBills,
  deletedBills,
} from "../../Redux/Reducers/Gastos";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import Calendar from "../Calendar/Calendar";

const Content3 = () => {
  let meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  let tipos = ["Casa", "Estudios", "Automovil", "Varios", "Entretenimiento"];
  const date = new Date();
  const [gastoForm, setGastoForm] = useState({
    nombre: "",
    dia: 0,
    monto: 0,
    tipo: "",
    mes: meses[date.getMonth()],
    id: JSON.parse(localStorage.getItem("userCredentials")).user.id,
  });
  const [modal, setModal] = useState("");
  const [modalTwo, setModalTwo] = useState("");
  const [showCalendar, setShowCalendar] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(meses[date.getMonth()]);
  console.log(selectedMonth);
  const mesActual = new Date().getMonth() + 1;
  const diasDelMes = Array.from(
    { length: new Date(new Date().getFullYear(), mesActual, 0).getDate() },
    (_, i) => i + 1
  );
  const opciones = diasDelMes.map((dia) => (
    <option key={dia} value={dia}>
      {dia}
    </option>
  ));
  const store = useSelector(Mygastos);
  const totalAnual =
    store.length === 0
      ? 0
      : store.reduce((acumulado, objeto) => acumulado + objeto.monto, 0);
  const total =
    store.length === 0
      ? 0
      : store
          .filter((item) => item.mes === selectedMonth)
          .reduce((acumulado, objeto) => acumulado + objeto.monto, 0);
  const media =
    store.length === 0
      ? 0
      : store
          .filter((item) => item.mes === selectedMonth)
          .reduce((acumulado, objeto) => acumulado + objeto.monto, 0) /
        store.length;
  const dispatch = useDispatch();

  const showACalendar = () => {
    if (showCalendar === "") {
      setShowCalendar("modalCalendario");
    } else {
      setShowCalendar("");
    }
  };
  const onChangeSelect = (e) => {
    setSelectedMonth(e.target.value);
    dispatch(
      getAllBillsByMes({
        usuarioId: JSON.parse(localStorage.getItem("userCredentials")).user.id,
        mes: meses.indexOf(e.target.value),
      })
    );
  };
  const addNewGasto = () => {
    dispatch(postBills(gastoForm));
    setModal("");
    window.location.reload();
  };

  const showModal = () => {
    if (modal === "") {
      setModal("show");
    } else {
      setModal("");
    }
  };
  const showModalTwo = () => {
    if (modalTwo === "") {
      setModalTwo("show");
    } else {
      setModalTwo("");
    }
  };
  const newGasto = (e) => {
    setGastoForm({ ...gastoForm, [e.target.name]: e.target.value });
  };

  const deletedABill = (id) => {
    dispatch(deletedBills({ id: id })).then(() => {
      Swal.fire({
        title: "¡Éxito!",
        text: "Gasto borrado = Mas plata.",
        icon: "success",
        confirmButtonText: "Aceptar",
      });
    });
  };

  const exitSession = () => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "¿Quieres cerrar la sesión?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("userCredentials");
        window.location.reload();
      } else {
      }
    });
  };
  useEffect(() => {
    dispatch(
      getAllBillsByMes({
        usuarioId: JSON.parse(localStorage.getItem("userCredentials")).user.id,
      })
    );
  }, []);
  return (
    <div className="content2-container">
      <div className="lateral-bar-content">
        <div className="title-lateral-bar">My bills</div>
        <div className="list-lateral-bar">
          <div className="items-lateral-bar">
            <button title="Dashboard">
              <svg
                width={40}
                height={40}
                viewBox="0 0 512 406.52"
                fill="#2A2835"
              >
                <path d="M512 0v339.71H336.77v34.2h51.21v32.61H122.93v-32.61h54.85v-34.2H0V0h512zM60.73 251.43h342.85v15.07H60.73v-15.07zm0-40.23H279.5v15.07H60.73V211.2zm334.59-84.15 58.05.2c-.05 15.9-6.28 31.12-17.31 42.28a59.295 59.295 0 0 1-8.49 7.1l-32.25-49.58zm-5.95-11.83-3.1-63.73c-.06-1.26.89-2.33 2.11-2.39.36-.02.78-.04 1.25-.05.39-.02.81-.02 1.25-.03 17.05-.19 32.69 6.45 44.38 17.5 11.69 11.05 19.42 26.52 20.64 43.99.08 1.26-.84 2.35-2.07 2.44l-62.08 4.56c-1.22.08-2.29-.86-2.37-2.12-.01-.06-.01-.11-.01-.17zm1.45-61.64 2.88 59.2 57.56-4.22c-1.62-15.33-8.64-28.88-19.01-38.68-10.89-10.3-25.46-16.48-41.33-16.3h-.1zm-8.4 70.74 31.12 55.36c-9.46 5.61-20.2 8.57-31.12 8.57-34.38 0-62.25-28.63-62.25-63.93 0-31.73 22.65-58.65 53.21-63.26l9.04 63.26zM204.76 55.94l-4.96-6.31c-.78-1.09-1.02-2.12-.7-3.07.84-2.56 3.86-2.31 5.95-2.17 5.94.43 19.95.56 23.01.68 2.24.16 3.55 1.84 3.17 4.05-.62 3.09-3.47 17.97-4.49 23.62-.36 1.96-.95 4.51-3.42 4.7-1 .08-1.94-.4-2.82-1.41l-4.95-6.32-2.3-2.92-30.93 20.03c-.39 7.79-6.83 13.99-14.72 13.99-8.14 0-14.74-6.6-14.74-14.74 0-.33.01-.66.03-.98l-17.1-12.35a14.583 14.583 0 0 1-8.41 2.64c-4.26 0-8.09-1.81-10.78-4.7L87.93 86.05c.06.5.08 1.01.08 1.53 0 8.14-6.6 14.74-14.73 14.74-8.14 0-14.74-6.6-14.74-14.74s6.6-14.74 14.74-14.74c2.95 0 5.69.87 8 2.36l31.55-16.91c1.12-7.02 7.21-12.39 14.55-12.39 8.14 0 14.74 6.6 14.74 14.74 0 .32-.01.65-.03.98l17.1 12.35a14.68 14.68 0 0 1 8.41-2.64c3.7 0 7.08 1.37 9.67 3.62l28.11-18.21-.62-.8zm6.78 38.03h20.32c1.17 0 2.13.96 2.13 2.13v78.95c0 1.17-.96 2.13-2.13 2.13h-20.32c-1.16 0-2.13-.96-2.13-2.13V96.1c0-1.17.96-2.13 2.13-2.13zm-49.47 27.06h20.32c1.17 0 2.13.96 2.13 2.13v51.89c0 1.17-.96 2.13-2.13 2.13h-20.32c-1.17 0-2.13-.96-2.13-2.13v-51.89c0-1.17.96-2.13 2.13-2.13zm-49.48-27.06h20.33c1.17 0 2.12.96 2.12 2.13v78.95c0 1.17-.96 2.13-2.12 2.13h-20.33c-1.16 0-2.12-.96-2.12-2.13V96.1c0-1.17.95-2.13 2.12-2.13zm-49.48 31.42h20.33c1.17 0 2.12.97 2.12 2.13v47.53c0 1.17-.96 2.13-2.12 2.13H63.11c-1.16 0-2.12-.96-2.12-2.13v-47.53c0-1.17.95-2.13 2.12-2.13zM15.28 296.18h481.37V15.28H15.28v280.9z" />
              </svg>
            </button>
            <button title="Exit" onClick={exitSession}>
              <svg height="40" width="40" viewBox="0 0 55 55">
                <g>
                  <path d="M53.924,23.618c-0.051-0.123-0.125-0.234-0.217-0.327L41.708,11.293c-0.391-0.391-1.023-0.391-1.414,0   s-0.391,1.023,0,1.414L50.587,23H29.001c-0.553,0-1,0.447-1,1s0.447,1,1,1h21.586L40.294,35.293c-0.391,0.391-0.391,1.023,0,1.414   C40.489,36.902,40.745,37,41.001,37s0.512-0.098,0.707-0.293l11.999-11.999c0.093-0.092,0.166-0.203,0.217-0.326   C54.025,24.138,54.025,23.862,53.924,23.618z" />
                  <path d="M36.001,29c-0.553,0-1,0.447-1,1v16h-10V8c0-0.436-0.282-0.821-0.697-0.953L8.442,2h26.559v16c0,0.553,0.447,1,1,1   s1-0.447,1-1V1c0-0.553-0.447-1-1-1h-34c-0.032,0-0.06,0.015-0.091,0.018C1.854,0.023,1.805,0.036,1.752,0.05   C1.658,0.075,1.574,0.109,1.493,0.158C1.467,0.174,1.436,0.174,1.411,0.192C1.38,0.215,1.356,0.244,1.328,0.269   c-0.017,0.016-0.035,0.03-0.051,0.047C1.201,0.398,1.139,0.489,1.093,0.589c-0.009,0.02-0.014,0.04-0.022,0.06   C1.029,0.761,1.001,0.878,1.001,1v46c0,0.125,0.029,0.243,0.072,0.355c0.014,0.037,0.035,0.068,0.053,0.103   c0.037,0.071,0.079,0.136,0.132,0.196c0.029,0.032,0.058,0.061,0.09,0.09c0.058,0.051,0.123,0.093,0.193,0.13   c0.037,0.02,0.071,0.041,0.111,0.056c0.017,0.006,0.03,0.018,0.047,0.024l22,7C23.797,54.984,23.899,55,24.001,55   c0.21,0,0.417-0.066,0.59-0.192c0.258-0.188,0.41-0.488,0.41-0.808v-6h11c0.553,0,1-0.447,1-1V30   C37.001,29.447,36.553,29,36.001,29z" />
                </g>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="central-screen-content">
        <div className="fichas">
          <div className="ficha-content">
            <div className="ficha">
              <h1>
                {store.filter((item) => item.mes === selectedMonth).length}
              </h1>
              <p>Total de gastos efectuados</p>
            </div>
            <div className="ficha">
              <h1>${total}</h1>
              <p>Total monto mensual</p>
            </div>
            <div className="ficha">
              <h1>${media}</h1>
              <p>Total media mensual</p>
            </div>
          </div>
        </div>
        <div className="central-table-content">
          <div className="filters">
            <select value={selectedMonth} onChange={onChangeSelect} id="mes">
              <option value="">Elija un mes</option>
              {meses.map((m, index) => {
                return (
                  <option
                    key={index}
                    disabled={index > date.getMonth()}
                    selected={m === meses[date.getMonth()]}
                    value={m}
                  >
                    {m}
                  </option>
                );
              })}
            </select>
            <select disabled className="elegit">
              <option value={""}> Elija un tipo de gasto</option>
              <option value={"todo"}>Todos</option>
            </select>
            <button className="clickandsee" onClick={showModalTwo}>
              Ver gastos historicos
            </button>
            <button className="clickandsee" onClick={showACalendar}>
              Ver calendario de gastos
            </button>
          </div>
          <div className="table-content">
            <div className="table">
              <div className="title-table">
                <div className="title-table-content">
                  <h1>Tus cuentas</h1>
                  <button
                    disabled={selectedMonth !== meses[date.getMonth()]}
                    className="addButton"
                    onClick={showModal}
                  >
                    Agregar
                  </button>
                </div>
              </div>
              <div className="list-gastos2">
                <div className="title-gastos-property">
                  <div className="gasto-name">
                    <p>
                      <b>Nombre</b>
                    </p>
                  </div>
                  <div className="gasto-mount">
                    <span>
                      <b>Monto</b>
                    </span>
                  </div>
                  <div className="type">
                    <p>
                      <b>Tipo</b>
                    </p>
                  </div>
                  <div className="day">
                    <p>
                      <b>Dia</b>
                    </p>
                  </div>
                  <div className="actions">
                    <p>
                      <b>Acciones</b>
                    </p>
                  </div>
                </div>{" "}
                {store.filter((item) => item.mes === selectedMonth).length ===
                0 ? (
                  <div className="empty">No ha registrado ningun gasto</div>
                ) : (
                  store
                    .filter((item) => item.mes === selectedMonth)
                    .map((g, index) => (
                      <div key={index} className="gastos">
                        <div className="gasto-name">
                          <p>{g.nombre}</p>
                        </div>
                        <div className="gasto-mount">
                          <p>{g.monto}</p>
                        </div>
                        <div className="type">
                          <p>{g.tipo}</p>
                        </div>
                        <div className="day">
                          <p>
                            {g.dia}/{date.getMonth() + 1}
                          </p>
                        </div>
                        <div className="actions">
                          <button
                            className="trash"
                            onClick={() => deletedABill(g.id)}
                          >
                            <svg
                              width="16"
                              height="19"
                              viewBox="0 0 16 19"
                              fill="none"
                            >
                              <path
                                d="M11.681 2.41458C11.7194 2.55015 11.874 2.66 12.0286 2.66H15.0175C15.5603 2.66 16 3.05682 16 3.54666C16 3.95141 15.6996 4.29181 15.2906 4.39869L14.7774 17.1327C14.7358 18.1687 13.7807 19 12.6294 19H3.37062C2.22147 19 1.26424 18.1678 1.22258 17.1327L0.709425 4.39869C0.300438 4.29181 0 3.95141 0 3.54666C0 3.05682 0.439696 2.66 0.982467 2.66H3.97141C4.12602 2.66 4.28173 2.54817 4.31901 2.41458L4.52844 1.65557C4.78831 0.717461 5.80587 0 6.87606 0H9.12388C10.1952 0 11.2116 0.717436 11.4715 1.65557L11.681 2.41458ZM7.29835 6.71337V15.3267C7.29835 15.676 7.61305 15.96 8.00011 15.96C8.38718 15.96 8.70187 15.676 8.70187 15.3267V6.71337C8.70187 6.36405 8.38718 6.08004 8.00011 6.08004C7.61305 6.08004 7.29835 6.36405 7.29835 6.71337ZM4.07025 6.73217L4.35095 15.3455C4.36301 15.6948 4.68648 15.9699 5.07354 15.96C5.46061 15.9491 5.76542 15.6572 5.75448 15.3079L5.47377 6.69458C5.46171 6.34526 5.13824 6.07016 4.75118 6.08004C4.36412 6.09093 4.0593 6.38285 4.07025 6.73217ZM10.5265 6.69457L10.2458 15.3078C10.2348 15.6572 10.5396 15.9491 10.9267 15.96C11.3137 15.9699 11.6372 15.6948 11.6493 15.3454L11.93 6.73216C11.9409 6.38284 11.6361 6.09093 11.249 6.08003C10.862 6.07014 10.5385 6.34525 10.5265 6.69457ZM6.41553 2.66H9.58441C9.66117 2.66 9.70941 2.60558 9.69077 2.53829L9.56467 2.08505C9.5241 1.93661 9.29274 1.77332 9.12388 1.77332H6.87606C6.7072 1.77332 6.47583 1.93661 6.43527 2.08505L6.30917 2.53829C6.29053 2.60657 6.33877 2.66 6.41553 2.66H6.41553Z"
                                fill="#EB5757"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    ))
                )}
              </div>
            </div>
            <div className="central-left">
              <div className="grafico-title">
                <h3>Grafico representativo de tus gastos</h3>
              </div>
              <div className="grafico"></div>
            </div>
          </div>
        </div>
      </div>
      <div className={`modal ${modal}`}>
        <div className="modal-content">
          <div className="modal-close">
            <h2>Ingreso de gasto</h2>
            <span onClick={showModal} className="cerrar">
              &times;
            </span>
          </div>
          <div className="modal-body">
            <div>
              <input
                onChange={newGasto}
                name="nombre"
                placeholder="Nombre del gasto"
                id="nombre"
              />
            </div>
            <div>
              <input
                onChange={newGasto}
                name="monto"
                placeholder="Cantidad del monto"
                id="monto"
                type={"number"}
              />
            </div>
            <div>
              <select name="dia" id="dia" onChange={newGasto}>
                <option value=""> Elegir dia</option>
                {opciones}
              </select>
            </div>
            <div>
              <select name="tipo" id="tipo" onChange={newGasto}>
                <option value="">Tipo de gasto</option>{" "}
                {tipos.map((d, index) => {
                  return (
                    <option key={index} value={d}>
                      {d}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <div className="button">
              <button className="addButton" onClick={addNewGasto}>
                Aceptar
              </button>
              <button onClick={showModal} className="addButton cancelar">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={`modalTwo ${modalTwo}`}>
        <div className="modalTwo-content">
          <div className="modalTwo-close">
            <h2>Lista de gastos anual</h2>
            <span onClick={showModalTwo} className="cerrar">
              &times;
            </span>
          </div>
          <div className="modal-body">
            <div className="container-modal-body">
              <div className="listGastosYear">
                <table>
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Monto</th>
                      <th>Tipo</th>
                      <th>Mes</th>
                      <th>Dia</th>
                    </tr>
                  </thead>
                  <tbody>
                    {store.map((dato) => (
                      <tr key={dato.id}>
                        <td>{dato.nombre}</td>
                        <td>{dato.monto}</td>
                        <td>{dato.tipo}</td>
                        <td>{dato.mes}</td>
                        <td>{dato.dia}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="listTotalYear">
              Total: $<b>{totalAnual}</b>
            </div>
          </div>
          <div className="modal-footer">
            <div className="button">
              <button onClick={showModalTwo} className="addButton cancelar">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={`modal ${showCalendar}  `}>
        <Calendar
          expenses={store.filter((item) => item.mes === selectedMonth)}
          showACalendar={showACalendar}
        />
      </div>
    </div>
  );
};
export default Content3;
/*


*/
